import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolumeOff = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.875 15.374L9.854 18.745C10.503 19.296 11.5 18.834 11.5 17.982V6.01698C11.5 5.16498 10.504 4.70298 9.854 5.25398L5.875 8.62498L3.5 8.625C2.948 8.625 2.5 9.073 2.5 9.625V14.375C2.5 14.927 2.948 15.375 3.5 15.375H5.875",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.83 9.44L15.83 14.44",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.83 14.44L15.83 9.44",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgVolumeOff);
export default ForwardRef;
